import { ACMEResponse } from '@b2b/types/core';
import { IInjectable } from '@uirouter/angularjs';
import { IPromise } from 'angular';
import { ApiService } from '../services/api/types';
import { ThemesHelperService } from '../services/themesHelper/types';

export interface ThemesData {
  version: number;
  variables: Record<string, string>;
  textVariables: Record<string, string>;
  links: {
    key: string;
    label: string;
    link: string;
  }[];
  company: {
    name: string;
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    companyLogo: string;
    companyUrl: string;
    brandedUrl: string;
    phoneNumber: string;
    giftCertificates: boolean;
    coupons: boolean;
    reviews: boolean;
    membership: boolean;
    membershipSales: boolean;
    membershipBenefitsExtension: number;
    membershipVerificationLastName: boolean;
    billingAddress: string;
    b2bBillingAddress: string;
    passwordSecurityPolicyEnabled: boolean;
    passwordMinimumLength: number;
    passwordUseMixedCase: boolean;
    passwordMinimumDigits: number;
    passwordMinimumSymbols: number;
    allowAMEX: boolean;
    auxiliaryMembership: boolean;
    notificationPreference: string;
    allowUpgradeExternalMemberships: boolean;
    sortTemplatesByDisplayOrder: boolean;
    allowTicketTransactionOnExpiredMemberships: boolean;
    enableSalesView: boolean;
    enableSalesTax: boolean;
    enable3DS: boolean;
    enableCORSCheckout: boolean;
    enableCustomerMerge: boolean;
    enableMembershipEmailValidation: boolean;
    enableAppsIntegration: boolean;
    enableEnhancedTemplatePublish: boolean;
    enableOptionalFeesV1: boolean;
    mid: string;
    paymentsPublishableKey: string;
    b2bPublishableKey: string;
    tenantId: number;
    timezoneOffset: string;
    timezone: string;
  };
  emailVariables: Record<string, string>;
  openHours: {
    id: string;
    standard: {
      weekdays: string[];
      hours: string[];
    }[];
    exceptions: {
      date: string;
      hours: string[];
      name: string;
    }[];
  };
  membershipConfig: {
    membershipCardLayouts: {
      cssText: string;
      htmlText: string;
    };
  };
  creditCardValidationSettings: {
    b2bValidation: string;
    b2bDisplay: string;
    b2cValidation: string;
    b2cDisplay: string;
  };
  featuresConfig: {
    objectLock: {
      lockAlwaysRequiredToUpdateRequiresLockObjects: boolean;
      lockExpiryInSeconds: number;
    };
    customers: {
      enableCustomersOrgCheckout: boolean;
    };
    coupons: {
      enableCoupons: boolean;
      allowMultiple: boolean;
    };
  };
  analyticsConfig: {
    enableGtm: boolean;
    acmeGtmTrackingCode: string;
    tenantGtmTrackingCode: string;
    enableGoogleAnalytics: boolean;
    acmeGoogleAnalyticsTrackingCode: string;
    tenantGoogleAnalyticsTrackingCode: string;
    tenantEmailGoogleAnalyticsTrackingCode: string;
  };
  customScripts: string;
}

export function ThemesDataResolver(options = { includeEmail: false }): IInjectable {
  return [
    'ApiService',
    'ThemesHelperService',
    function ThemesData(
      apiService: ApiService,
      themesHelperService: ThemesHelperService
    ): IPromise<{ data: ACMEResponse<ThemesData> }> {
      return apiService.themes.detail(options.includeEmail).then((response) => {
        if (response.data.success) {
          themesHelperService.setModel(response.data.payload);
        }

        return response;
      });
    },
  ];
}
